const state = {
  sets: [],
  set: {}
};

export default {
  namespaced: true,
  state,
  mutations: {
    setSets(state, sets) {
      state.sets = sets;
    },
    setSet(state, set) {
      state.set = set;
    }
  },
  actions: {
    fetchSets({ commit }, payload) {
      const { dontPaginate, filter, paginationcount, sold } = payload;
      if (!!dontPaginate || typeof dontPaginate === 'undefined') {
        commit('SET_LOADING', true, { root: true });
        if (!!filter || typeof filter === 'undefined') {
          return axios
            .get('api/v1/set', {
              params: {
                page: payload.page,
                filter: filter,
                paginationcount: paginationcount,
                sold: sold
              }
            })
            .catch(error => {
              if (error.response.status == 403) {
                commit(
                  'SET_SNACK_BAR',
                  {
                    message: error.response.data['message'],
                    color: 'error'
                  },
                  { root: true }
                );
              }
            })
            .then(response => {
              commit('setSets', response.data);
            })
            .finally(() => commit('SET_LOADING', false, { root: true }));
        }
        return axios
          .get('api/v1/set', {
            params: { page: payload.page, paginationcount: paginationcount, sold: sold }
          })
          .then(response => {
            commit('setSets', response.data);
          })
          .catch(error => {
            if (error.response.status == 403) {
              commit(
                'SET_SNACK_BAR',
                {
                  message: error.response.data['message'],
                  color: 'error'
                },
                { root: true }
              );
            }
          })
          .finally(() => commit('SET_LOADING', false, { root: true }));
      } else {
        return axios.get('api/v1/set', { params: { paginate: 0 } }).then(response => {
          commit('setSets', response.data);
        });
      }
    },
    getSet({ commit }, payload) {
      return axios
        .get(`api/v1/set/${payload.id}`)
        .then(response => {
          commit('setSet', response.data);
        })
        .catch(error => {
          if (error.response.status == 403) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
          }
        })
        .catch(error => {
          if (error.response.status == 404) {
            commit(
              'SET_SNACK_BAR',
              {
                message: error.response.data['message'],
                color: 'error'
              },
              { root: true }
            );
            commit('setSet', {});
          }
        });
    }
  }
};
